'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _Defaults = require('../constants/Defaults');

var _TargetAudienceTypes = require('../constants/TargetAudienceTypes');

var _TargetAudienceTypes2 = _interopRequireDefault(_TargetAudienceTypes);

var _UnassignedRoutingRules = require('../routing-rules/records/UnassignedRoutingRules');

var _UnassignedRoutingRules2 = _interopRequireDefault(_UnassignedRoutingRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  active: true,
  askForEmail: true,
  askForEmailMessage: null,
  captureVisitorEmailAddress: true,
  chatHeadingConfig: null,
  connectedAccountId: null,
  consentToCommunicateSubscriptionId: null,
  createdAt: null,
  creatorId: null,
  customAwayMessage: null,
  customConsentToProcessMessage: null,
  customConsentToCommunicateMessage: null,
  customEmailCaptureDelay: null,
  exclusionListIds: (0, _immutable.List)(),
  exclusionUrls: (0, _immutable.List)(),
  fallbackUser: null,
  hideWhenOffline: false,
  id: _Defaults.DEFAULT_MESSAGE_ID,
  inboxId: null,
  inclusionListIds: (0, _immutable.List)(),
  inclusionUrls: (0, _immutable.List)(),
  initialMessage: null,
  language: null,
  lastEditedAt: null,
  lastEditorId: null,
  name: null,
  popMessageOnSmallScreens: true,
  popOpenWelcomeMessage: true,
  portalId: null,
  gdprConsentToProcessEnabled: false,
  gdprConsentToCommunicateEnabled: false,
  gdprExplicitConsentRequired: true,
  richTextSupported: false,
  rotatingToOwner: null,
  routingRulesId: null,
  routingRules: (0, _UnassignedRoutingRules2.default)(),
  sendFromRoutingRules: null,
  showOnSmallScreens: true,
  targetAudienceId: null,
  targetAudienceType: _TargetAudienceTypes2.default.ALL_VISITORS,
  targetedMessageSource: null,
  targetingRules: (0, _immutable.List)(),
  teamIds: (0, _immutable.List)(),
  type: null,
  userIds: (0, _immutable.List)()
}, 'Message');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/Message.js
// module id = 92
// module chunks = 2 3